var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hint)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
      customClass: 'custom-tooltip',
      title: _vm.hint,
      }),expression:"{\n      customClass: 'custom-tooltip',\n      title: hint,\n      }",modifiers:{"hover":true}}],staticClass:"hint-icon"},[_vm._v(" ? ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }